/* eslint-disable @typescript-eslint/no-explicit-any */
/** Push object inside array of objects if key/id does not exist otherwise update existing object with matching key value  */
function pushOrUpdateByKey<T extends ObjectOf<any>>(params: {
  arr: Array<T>;
  obj: T;
  key: string;
}): Array<T> {
  let { arr, obj, key } = params;
  const index = arr.findIndex((e) => e[key] === obj[key]);

  if (index === -1) {
    arr.push(obj);
  } else {
    arr[index] = obj;
  }
  return arr;
}

export default pushOrUpdateByKey;
